import { render, staticRenderFns } from "./vk.vue?vue&type=template&id=301cb8f8&scoped=true&"
import script from "./vk.vue?vue&type=script&lang=js&"
export * from "./vk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301cb8f8",
  null
  
)

export default component.exports